export var Animation;

(function (Animation) {
  Animation["SLIDELEFT"] = "slideLeft";
  Animation["SLIDERIGHT"] = "slideRight";
  Animation["SLIDEUP"] = "slideUp";
})(Animation || (Animation = {}));